import { render, staticRenderFns } from "./ContactDetailsBlock.vue?vue&type=template&id=571d05cf&"
import script from "./ContactDetailsBlock.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsBlock.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports